import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultConversatoinSummaryInfo } from '../interfaces/ConversationIf'
import { useAuth } from './useAuth'

interface C803ConversationSummaryGetProps {
  execConversationSummaryGet: (
    convId: string,
    idToken?: string,
  ) => Promise<ResultConversatoinSummaryInfo>
  loading: loadStatus
}
// C803 会話要約取得API呼出
export const useC803ConversationSummaryGet = (): C803ConversationSummaryGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execConversationSummaryGet = async (convId: string, idToken?: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = idToken ? idToken : await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(
        `${baseUrl}${stage}${apiUrl.conversationsPath}${convId}/summary`,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execConversationSummaryGet, loading }
}
